import { NgModule } from '@angular/core';
import { SvcBtnIconModule } from './svc-btn-icon/svc-btn-icon.module';
import { SvcFilledBtnIconModule } from './svc-filled-btn-icon/svc-filled-btn-icon.module';
import { SvcOutlinedBtnIconModule } from './svc-outlined-btn-icon/svc-outlined-btn-icon.module';

@NgModule({
  declarations: [],
  imports: [
    SvcBtnIconModule,
    SvcFilledBtnIconModule,
    SvcOutlinedBtnIconModule,
  ],
  exports: [
    SvcBtnIconModule,
    SvcFilledBtnIconModule,
    SvcOutlinedBtnIconModule,
  ]
})
export class SvcButtonIconModule { }
